import { Alert } from "@mui/material";
import Notify from "config/notify";
import { useEffect, useState } from "react";
import { AlertState } from "type";

/**
 * the global AlertApp
 */
export default function AlertApp() {
  const [alert, setAlert] = useState<AlertState>({
    show: false,
    severity: "info",
    message: "",
  });

  useEffect(() => {
    Notify.setAlert = setAlert;
  }, []);

  useEffect(() => {
    if (alert.show) {
      setTimeout(() => {
        setAlert({ show: false, severity: "info", message: "" });
        Notify.onClose?.();
      }, Notify.timeoutClose);
    }
  }, [alert.show]);

  const handleClose = () => {
    setAlert({ show: false, severity: "info", message: "" });
    Notify.onClose?.();
  };

  if (!alert.show) return null;

  return (
    <Alert
      style={{
        zIndex: 9999,
        position: "absolute",
        top: 68,
        transform: "translate(-50%, -50%)",
        left: "50%",
        margin: "auto",
      }}
      severity={alert.severity}
      onClose={handleClose}
    >
      {alert.message}
    </Alert>
  );
}
